import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore"; 

const firebaseConfig = {
  apiKey: "AIzaSyCW198bn-nqedaciCrg7sULQGDrE9CKuIo",
  authDomain: "custom-dashboard-2.firebaseapp.com",
  projectId: "custom-dashboard-2",
  storageBucket: "custom-dashboard-2.firebasestorage.app",
  messagingSenderId: "571388960651",
  appId: "1:571388960651:web:90278fc9c9c97cce70d98e",
  measurementId: "G-Q1FXDG34R0"
};


const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app); 


export { auth, db };

